<template>
  <v-container fluid>
    <!-- ヘッダー -->
    <v-row>
      <v-col cols="12">
        <h2>
          <v-icon class="mr-2">
            mdi-bell-outline
          </v-icon>
          お知らせ
        </h2>
        <v-spacer class="mt-2" />
      </v-col>
    </v-row><!-- /ヘッダー -->

    <!-- 検索ブロック -->
    <v-row>
      <v-col>
        <v-expansion-panels accordion>
          <v-expansion-panel>
            <v-expansion-panel-header class="panel-header-color panel-selectable">
              <strong>
                <v-icon class="panel-header-color">
                  mdi-magnify
                </v-icon>
                &nbsp;条件を指定して検索
              </strong>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="searchForms.title"
                        background-color="white"
                        dense
                        hide-details="auto"
                        label="タイトル"
                        outlined
                        rounded
                        persistent-placeholder
                        clearable
                        @blur="searchButtonClickEvent"
                        @click:clear="searchForms.title = null; searchButtonClickEvent()"
                      />
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-select
                        v-model="searchForms.notification_type"
                        :items="notificationTypes"
                        dense
                        hide-details="auto"
                        label="種別"
                        clearable
                        outlined
                        persistent-placeholder
                        rounded
                        @change="searchButtonClickEvent"
                      />
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-checkbox
                        v-model="searchForms.use_important"
                        label="重要のみを検索"
                        dense
                        hide-details="auto"
                        @change="searchButtonClickEvent"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn color="primary" @click="searchButtonClickEvent">
                    <v-icon>
                      mdi-magnify
                    </v-icon>
                    &nbsp;検索
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <!-- /検索ブロック -->

    <!-- ボタン -->
    <v-row>
      <v-col cols="12" class="text-right">
        <v-btn
          color="info"
          @click="exportButtonClickEvent"
        >
          <v-icon>mdi-file-download-outline</v-icon>&nbsp;CSV出力
        </v-btn>
      </v-col>
    </v-row>
    <!-- /ボタン -->

    <v-row>
      <v-col>
        <custom-pagination
          :page-number="page"
          :per-page="perPage"
          :pagination="pagination"
          :total-visible="totalVisible"
          @pageChanged="changePage"
          @perPageChanged="changePerPage"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card class="rounded-card" flat>
          <v-data-table
            :headers="tableHeaders"
            :items="notifications"
            :items-per-page="-1"
            disable-sort
            hide-default-footer
          >
            <!-- 既読 -->
            <template v-slot:[`item.reading`]="{ item }">
              <v-list-item-icon>
                <v-icon
                  v-if="!item.reading"
                  small
                  color="primary"
                >
                  mdi-circle
                </v-icon>
              </v-list-item-icon>
            </template>
            <!-- /既読 -->

            <!-- 種別 -->
            <template v-slot:[`item.notification_type`]="{ item }">
              <v-chip
                small
                label
                dark
                :color="item.notification_type | notification_type_chip_color"
              >
                <v-icon
                  v-if="item.use_important"
                  left
                >
                  mdi-star
                </v-icon>
                {{ item.notification_type | notification_type_to_label }}
              </v-chip>
            </template>
            <!-- /種別 -->

            <template v-slot:[`item.editable`]="{item}">
              <v-btn
                v-if="$vuetify.breakpoint.mdAndUp"
                icon
                color="info darken-2"
                @click="showButtonClickEvent(item)"
              >
                <v-icon>mdi-file-document-outline</v-icon>
              </v-btn>
              <v-btn
                v-else
                text
                color="info"
                @click="showButtonClickEvent(item)"
              >
                参照する
              </v-btn>
            </template>
            <template v-slot:footer>
              <v-card flat>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="primary"
                    dark
                    @click="markAllAsRead"
                   >
                     一括既読
                  </v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <!-- ページャ -->
    <v-row>
      <v-col>
        <custom-pagination
          :page-number="page"
          :per-page="perPage"
          :pagination="pagination"
          :total-visible="totalVisible"
          @pageChanged="changePage"
          @perPageChanged="changePerPage"
        />
      </v-col>
    </v-row>
    <!-- /ページャ -->

    <!-- /ダイアログ -->
    <notification-show-dialog
      :enable-dialog="enableNotificationDialog"
      :target-id="targetId"
      @closeEvent="closeNotificationDialog"
      @registerEvent="notificationCallback"
      @refreshEvent="refreshNotification"
    />
    <!-- ダイアログ -->
  </v-container>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex'
import DownloadMixin from '../../../mixins/download-mixin'
import NotificationShowDialog from './dialogs/NotificationShowDialog'
import CustomPagination from "@/driver/components/_CustomPagination.vue";
export default {
  name: 'DriverNotificationIndex',
  components: {
    CustomPagination,
    NotificationShowDialog
  },
  mixins: [DownloadMixin],
  data () {
    return {
      page: 1,
      perPage: 50,
      totalVisible: 7,
      // display_end_date: null,
      targetId: null,
      enableNotificationDialog: false,
      enableEndDatePicker: false,
      collectedEndDate: null,
      searchForms: {
        title: null,
        use_important: false,
        notification_type: null,
      },
      notificationTypes: [
        { value: 'jwnet_notification', text: 'JWNET' },
        { value: 'dxe_notification', text: 'DXE' },
      ],
      tableHeaders: [
        { value: 'reading', text: '' },
        { value: 'notification_at', text: '日時' },
        { value: 'notification_type', text: '種別' },
        { value: 'title', text: 'タイトル' },
        { value: 'display_end_at', text: '表示期限' },
        { text: '詳細', value: 'editable', align: 'end' },
      ],
      notifications: [],
    }
  },
  computed: {
    ...mapGetters('DriverNotification', [
      'hasResult'
    ]),
    ...mapState('DriverNotification', {
      pagination: 'pagination',
      searchCondition: 'condition',
    }),
  },
  created() {
    if (this.$route.params.resetCondition) {
      this.resetState()
    } else {
      this.collectedEndDate = this.searchCondition.display_end_at
      this.searchForms.use_important = this.searchCondition.use_important
      this.searchForms.title = this.searchCondition.title
      this.perPage = this.searchCondition.limit
    }

    this.searchNotification()
  },
  methods: {
    ...mapActions('DriverNotification', {
      fetchNotifications: 'index',
      resetState: 'resetState'
    }),
    ...mapActions('DriverNotificationAlert', {
      fetchUnreadCount: 'fetchUnreadCount',
    }),
    ...mapActions('DriverNotificationBulkRead', {
      postBulkReads: 'create'
    }),
    markAllAsRead() {
      this.postBulkReads().then(()=>{
      this.searchButtonClickEvent()
      })
    },
    showButtonClickEvent (item) {
      this.targetId = item.id
      this.enableNotificationDialog = true
    },
    closeNotificationDialog () {
      this.enableNotificationDialog = false
    },
    notificationCallback () {
      this.closeNotificationDialog()
    },
    refreshNotification (id) {
      for (const notification of this.notifications) {
        if (notification.id === id) {
          notification.reading = true
          break
        }
      }
      this.fetchUnreadCount()
    },
    searchButtonClickEvent () {
      this.page = 1
      this.searchNotification()
    },
    changePage(page) {
      this.page = page;
      this.searchNotification()
    },
    changePerPage (perPage) {
      this.perPage = perPage
      this.page = 1
      this.searchNotification()
    },
    exportButtonClickEvent () {
      let params = this.buildParam('csv')
      this.fetchNotifications(params).then((content) => {
        this.downloadCsv(content, 'お知らせ')
      })
    },
    searchNotification () {
      let params = this.buildParam('json')
      this.fetchNotifications(params).then((content) => {
        this.notifications = content.notifications
      })
    },
    buildParam (format) {
      const params = {
        display_end_at: this.collectedEndDate,
        title: this.searchForms.title,
        use_important: this.searchForms.use_important,
        notification_type: this.searchForms.notification_type,
        limit: this.perPage,
        page: this.page,
        format: format
      }
      return params
    },
  }
}
</script>

<style scoped lang="scss">
.panel-header-color {
  color: #0D74BA !important;
  & .v-expansion-panel-header__icon {
    & .v-icon {
      color: #0D74BA !important;
      &::before {
        color: #0D74BA !important;
      }
    }
  }
}
.panel-selectable {
  background-color: #DCE7EB;
}

</style>
